module.exports = __webpack_public_path__ + "static/API 3-4706bbe854d16df7bdb5435b13435160.png";